import dynamic from "next/dynamic"

import type { AppBannerProps } from "./AppBanner"

const DynamicAppBanner = dynamic<AppBannerProps>(() => import("./AppBanner").then(mod => mod.AppBanner), {
  ssr: false,
})

export default DynamicAppBanner
